import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({

})

class ButtonGroup extends React.Component {

    state = {
        anchorEl: null,
    }

    handleClick = event => {
        this.setState({
            anchorEl: event.currentTarget
        })
    }

    handleClose = () => {
        this.setState({
            anchorEl: null
        })
    }

    render() {

        const { anchorEl } = this.state;
        var { groupName, links } = this.props;

        return (
            <div style={{display:"inline-block"}}>
                <Button
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    {groupName}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                >
                    {links.map((link) => {
                        var menuItem = <span />
                        if(link.divider) {
                            return <Divider />
                        }
                        if(link.icon) {
                            return <MenuItem onClick={link.onClick}>
                                <ListItemIcon>
                                    {link.icon}
                                </ListItemIcon>
                                <ListItemText inset primary={link.label} />
                            </MenuItem>
                        } else {
                            return <MenuItem onClick={link.onClick}>{link.label}</MenuItem>
                        }
                    })}

                </Menu>
            </div>
        )
    }

}

export default withStyles(styles)(ButtonGroup);



// WEBPACK FOOTER //
// ./src/Components/ButtonGroup.js